import React, { useEffect, useState } from 'react'
import '../../ChildComponent.css';
import DetailRow from '@components/common/DetailRow';
import { COMMON_CONSTANTS, DeathDetailsDataView, FIELD_CONSTANTS, NewBornDetailsData, ServiceReportCodeForChild } from './NewBornForm/NewBornConstants';
import { errorLogger } from '@utils/applicationLogUtils';
import { getData, postDataJSON } from '@services/CommonApiService';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import endpoints from '@config/endpoints';
import { formatName } from '@pages/Beneficiary-block/WomenComponent/PregnancyTracking/pregnancyUtils';
import { updatePNC } from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';
import { desiredFormatDate } from '@utils/commonUtils';
import { dateFormate } from '@constants/index';

interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
}

export interface formStateType {
  [key: string]: objectType;
}

const NewBornView = () => {
    const [newBornDetails, setNewBornDetails] = useState<any>(null);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);

    const dispatch = useDispatch();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await getData<any>(`${endpoints.CompletedServiceList}/${childDetails?.benef_id}`)
            if (res) {
                mapData(res);
                fetchDataChildDeathDetails();
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const fetchDataChildDeathDetails = async () => {
        try {
            const deathDetailsRes = await getData<any>(`${endpoints.childDeathDetails(childDetails?.benef_id)}`);

            if (deathDetailsRes) {
                deathViewData(deathDetailsRes?.data?.[0]);
                setNewBornDetails((prevState: any) => {
                    return {
                        ...prevState,
                        ['deathRelatedInformation']: {
                          ...prevState['deathRelatedInformation'],
                          value: deathDetailsRes?.data?.length > 0 ? 'Yes' : 'No'
                        },
                      }
                });
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const mapData = (data: any) => {
        const initialState: any = {};
    
        Object.keys(JSON.parse(JSON.stringify(NewBornDetailsData))).forEach((key) => {
            initialState[key] = { value: null };
        });
    
      const updatedFormState = data?.data?.reduce((acc: any, item: any) => {
            const value = item.service_report;
            const serviceCode = item.service_code;
            switch (serviceCode) {
                case ServiceReportCodeForChild.babyCriedImmediatelyAtBirth:
                    acc.babyCried.value = value;
                    break;
                case ServiceReportCodeForChild.referredForFurtherManagement:
                    acc.referred.value = value;
                    break;
                case ServiceReportCodeForChild.isChildAdmittedInNbsuSncuNicu:
                    acc.isChildAdmitted.value = value;
                    break;
                case ServiceReportCodeForChild.anyVisibleBirthDefectSeen:
                    acc.birthDefectSeen.value = value;
                    break;
                case ServiceReportCodeForChild.treatedOrReferred:
                    acc.ifDefectIdentified.value = value;
                    break;
                case ServiceReportCodeForChild.methodOfTreatment:
                    acc.methodOfTreatment.value = value;
                    break;
                case ServiceReportCodeForChild.breastFeeding:
                    acc.breastFeeding.value = value;
                    break;
                case ServiceReportCodeForChild.hivPositive:
                    acc.isTestedForHIV.value = value;
                    break;
                case ServiceReportCodeForChild.isNevirapineSyrupStartedAtBirth:
                    acc.isNevirapineSyrupStarted.value = value;
                    break;
                case ServiceReportCodeForChild.hbig:
                    acc.hbigVaccination.value = item?.service_date ? desiredFormatDate(item.service_date, dateFormate.dd_mm_yyyy) : '';
                    break;
                case ServiceReportCodeForChild.opv0:
                    acc.opv0Vaccination.value = desiredFormatDate(item.service_date, dateFormate.dd_mm_yyyy);
                    break;
                case ServiceReportCodeForChild.bcg:
                    acc.bcgVaccination.value = desiredFormatDate(item.service_date, dateFormate.dd_mm_yyyy);
                    break;
                case ServiceReportCodeForChild.hepb0:
                    acc.hepB0Vaccination.value = desiredFormatDate(item.service_date, dateFormate.dd_mm_yyyy);
                    break;
                case ServiceReportCodeForChild.vitK:
                    acc.vitaminKGiven.value = desiredFormatDate(item.service_date, dateFormate.dd_mm_yyyy);
                    break;
                case ServiceReportCodeForChild.aefiReported:
                    acc.whetherAefiReported.value = value;
                    break;
                case ServiceReportCodeForChild.syphilisCurativeCareGiven:
                    acc.syphilisTest.value=value
                    break;
                case ServiceReportCodeForChild.referredToNACP:
                    acc.referredToNacpReferralFacility.value=value
                    break;
                default:
                  break;
            }
            return acc;
    }, initialState);
    
        const facilityDetailsObj = data?.data[0];
    
        if (facilityDetailsObj) {
            const { facility_name, facility_type_name, healthprovider_f_name, healthprovider_l_name, mobiliser_f_name, mobiliser_l_name } = facilityDetailsObj;
            const healthProviderName = formatName(healthprovider_f_name, healthprovider_l_name);
            const mobiliserName = formatName(mobiliser_f_name, mobiliser_l_name);
            const localFacilityDetails = { facility_name, facility_type_name, healthProviderName, mobiliserName };
    
            dispatch(updatePNC("viewAndEditFacilityDetails", localFacilityDetails));
        }
        setNewBornDetails(updatedFormState);

        setNewBornDetails((prevState: any) => ({
            ...prevState,
            deathRelatedInformation: {
                ...prevState.deathRelatedInformation,
                value: prevState.deathRelatedInformation?.value ?? 'No'
            }
        }));
    };

    const deathViewData = (data:any) => {
        Object.entries(data).forEach(([key, value]) => {
            if (DeathDetailsDataView[key]) {
                if (key === COMMON_CONSTANTS.DATE_OF_DEATH) {
                    DeathDetailsDataView[COMMON_CONSTANTS.DATE_OF_DEATH].value = desiredFormatDate(value, dateFormate.dd_mm_yyyy);
                    DeathDetailsDataView[COMMON_CONSTANTS.TIME_OF_DEATH].value = desiredFormatDate(value, dateFormate.hh_mm_A)
                } else {
                    DeathDetailsDataView[key].value = (typeof value === COMMON_CONSTANTS.BOOLEAN) ? value ? 'Yes' : 'No' : value;
                }
            }
        });
    };
    const showNotDone = (key: string) => {
        if ((key === FIELD_CONSTANTS.SYPHILIS_TEST || key === FIELD_CONSTANTS.IS_TESTED_FOR_HIV) && !newBornDetails?.[key]?.value) {
          return COMMON_CONSTANTS.NOT_DONE;
        }
        return newBornDetails?.[key]?.value;
      };
  
  return (
    <>
      <div className="child-view-content">
        <div className="child-view-details">
          <div className="child-view-header-container">{COMMON_CONSTANTS.NEW_BORN_DETAILS}</div>
          <div className="child-details">
          {NewBornDetailsData && 
                    Object.keys(NewBornDetailsData).map((key) => {
                    const field = NewBornDetailsData[key];
                    return (
                        <DetailRow
                        key={key}
                        label={field["#title"]}
                        value={showNotDone(key)}
                        />
                    );
                    })}
          </div>
        </div>
        {(newBornDetails && (newBornDetails?.['deathRelatedInformation']?.value && newBornDetails?.['deathRelatedInformation']?.value === 'Yes')) && <div className="child-view-details">
          <div className="child-view-header-container">{COMMON_CONSTANTS.DEATH_DETAILS}</div>
          <div className="child-details">
          {DeathDetailsDataView && 
                    Object.keys(DeathDetailsDataView).map((key) => {
                    return (
                        <DetailRow
                        key={key}
                        label={DeathDetailsDataView?.[key]?.title}
                        value={DeathDetailsDataView?.[key]?.value}
                        />
                    );
                    })}
          </div>
        </div>}
      </div>
    </>
  );
};

export default NewBornView;
